import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchPanelComponent } from './search-panel/search-panel.component';
import { AgentGridComponent } from './agent-grid/agent-grid.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { HomescreenComponent } from './homescreen/homescreen.component';
import { AgentsComponent } from './agents/agents.component';
import { AgentModalComponent } from './agent-modal/agent-modal.component';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { LoadingPanelComponent } from './loading-panel/loading-panel.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from '@angular/forms';
import { AdvancedSearchCategoryComponent } from './advanced-search-category/advanced-search-category.component';

@NgModule({
  declarations: [
    AppComponent,
    SearchPanelComponent,
    AgentGridComponent,
    AdvancedSearchComponent,
    HomescreenComponent,
    AgentsComponent,
    AgentModalComponent,
    LoadingPanelComponent,
    AdvancedSearchCategoryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule 
  ],
  providers: [{provide: APP_BASE_HREF, useValue: ''}],
  bootstrap: [AppComponent]
})
export class AppModule { }
